import { Link } from "react-router-dom";
import { ArrowRight, PackageSearch } from "lucide-react";
import { formatPrice } from "@/lib/store";
import { ArrivalAlert } from "./ArrivalAlert";

const ROW = "group flex w-full items-center gap-3 rounded-xl px-2 py-2.5 text-left transition-colors hover:bg-white/5";
const Label = ({ children }) => <p className="mb-2 px-2 text-xs font-medium uppercase tracking-[0.14em] text-zinc-400">{children}</p>;

export const SearchShortcuts = ({ items }) => (
  <div data-testid="search-shortcuts">
    <Label>Atalhos rápidos</Label>
    <ul>
      {items.map((s) => (
        <li key={s.key}>
          <button data-testid={`search-shortcut-${s.key}`} onClick={s.onClick} className={ROW}>
            <ArrowRight className="h-4 w-4 text-zinc-400 transition-transform duration-300 group-hover:translate-x-0.5" />
            <span className="text-[15px] text-zinc-200 group-hover:text-white">{s.label}</span>
          </button>
        </li>
      ))}
    </ul>
  </div>
);

const sub = (p) => [p.storage, p.color, p.wattage].filter(Boolean).join(" · ");

export const SearchResults = ({ list, onPick, onOrder, query }) => (
  <div data-testid="search-results">
    <Label>{list.length} {list.length === 1 ? "resultado" : "resultados"}</Label>
    <ul>
      {list.slice(0, 8).map((p) => (
        <li key={p.id}>
          <Link to={`/produto/${p.id}`} onClick={onPick} data-testid={`search-result-${p.id}`} className={ROW}>
            <span className="h-12 w-12 shrink-0 overflow-hidden rounded-xl bg-zinc-900">
              {p.images?.[0] && <img src={p.images[0]} alt="" loading="lazy" decoding="async" className="h-full w-full object-cover" />}
            </span>
            <span className="min-w-0 flex-1">
              <span className="block truncate text-[15px] font-semibold text-white">{p.model}</span>
              <span className="block truncate text-xs text-zinc-400">{sub(p) || "\u00a0"}</span>
            </span>
            <span className="shrink-0 text-sm font-semibold text-zinc-200">{formatPrice(p.price)}</span>
          </Link>
        </li>
      ))}
    </ul>
    <button data-testid="search-order-link" onClick={onOrder} className={`${ROW} mt-2 border-t border-white/10 pt-4`}>
      <ArrowRight className="h-4 w-4 text-zinc-400" />
      <span className="text-sm text-zinc-300 group-hover:text-white">Não é bem isso? Encomendar “{query}”</span>
    </button>
  </div>
);

export const SearchEmpty = ({ query, onOrder, onAlert }) => (
  <div data-testid="search-empty" className="rounded-[24px] border border-white/10 bg-white/[0.03] p-6 sm:p-8">
    <PackageSearch className="h-8 w-8 text-white" strokeWidth={1.6} />
    <p className="font-display mt-4 text-xl font-bold text-white sm:text-2xl">Não temos “{query}” no estoque agora.</p>
    <p className="mt-2 text-sm text-zinc-400">A gente encomenda para você, com entrega em até 7 dias corridos, ou te avisa assim que chegar na loja.</p>
    <div className="mt-6 flex flex-col items-start gap-4 sm:flex-row sm:flex-wrap">
      <button data-testid="search-order-button" onClick={onOrder} className="inline-flex items-center gap-2 rounded-full bg-white px-6 py-3 text-sm font-bold text-black transition-transform duration-300 hover:scale-[1.03] active:scale-95">
        Fazer pedido <ArrowRight className="h-4 w-4" />
      </button>
      <ArrivalAlert key={query} query={query} onAlert={onAlert} />
    </div>
  </div>
);
